import { QueryClient } from '@tanstack/react-query'

// Singleton React Query client. Lives in its own module (not inside
// main.tsx) so non-React call sites — specifically the api/client.ts
// 401 interceptor — can import it and call `.clear()` on logout. Without
// that, the previous account's cache (feed, relatives, etc.) survives
// the auth swap and the new account briefly sees the old user's data
// until refetch.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      retry: 2,
    },
  },
})
